import React, { useState, useEffect, useContext } from "react";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";
import { AuthContext } from "../../utility/services/AuthContext";
import { trackScreenView, getUserTrackingParams } from "../../utility/services/analyticsService";

const questionAnswerArr = [
  {
    q: `How does eCareTherapy LLC connect individuals with therapists
    and mental health professionals?`,
    a: `eCareTherapy LLC connects individuals with licensed therapists
    and mental health professionals through an online counseling and
    therapy platform.`,
  },
  {
    q: `What criteria can users use to choose their own therapist on eCareTherapy?`,
    a: `Users can select their therapist based on criteria such as specialties, genders, pricing, languages, and ratings.`,
  },
  {
    q: ` Does eCareTherapy require a subscription for users to access its services?
    `,
    a: `No, eCareTherapy does not require a subscription for users to access its services.`,
  },
  {
    q: `What types of communication sessions are provided on eCareTherapy?
    `,
    a: `eCareTherapy offers secure and encrypted video, audio, or chat sessions to facilitate communication between therapists and patients.`,
  },
  {
    q: ` How does eCareTherapy handle payment processing for therapy sessions?
    `,
    a: ` eCareTherapy uses the Stripe payment gateway for processing payments and does not store any payment information for therapists or patients.`,
  },
  {
    q: `How do therapists set their rates for services on eCareTherapy?
    `,
    a: `Therapists have the flexibility to set their own rates for services provided through the platform, starting from a minimum amount, and can adjust them as needed.
    `,
  },
  {
    q: `What is the focus of eCareTherapy LLC in terms of privacy and security?`,
    a: `eCareTherapy prioritizes privacy and security by not storing any payment information and by offering secure and encrypted communication channels for therapy sessions.`,
  },
  {
    q: `How does eCareTherapy facilitate rebooking sessions with a preferred therapist?
    `,
    a: `If a patient is satisfied with a particular therapist, they can rebook sessions with that therapist for ongoing care.`,
  },
  {
    q: `What does eCareTherapy emphasize in its approach to mental health support?
    `,
    a: `eCareTherapy emphasizes accessibility, choice, and quality care in its approach to mental health support.
    `,
  },
  {
    q: `What level of control do therapists have over their schedules on eCareTherapy?
    `,
    a: `Therapists have the ability to manage their schedules and availability on the eCareTherapy platform.`,
  },
  {
    q: `How does eCareTherapy aim to revolutionize access to mental health services?
    `,
    a: `eCareTherapy aims to revolutionize access to mental health services by providing a user- friendly platform that prioritizes mental well-being and fosters meaningful connections between therapists and individuals seeking support.`,
  },
  {
    q: `What percentage of the payment does eCareTherapy retain as a service fee for facilitating therapy sessions?
    `,
    a: `eCareTherapy retains 20% of the payment as a service fee, with 80% being immediately transferred to the therapist upon completing a session.
    `,
  },
  {
    q: `How does eCareTherapy facilitate the initial connection between clients and therapists?`,
    a: `eCareTherapy facilitates the initial connection by allowing clients to browse through a list of therapists, review their profiles, and book appointments based on the therapists' availability.`,
  },
  {
    q: ` Can users filter therapists who are currently available and ready to be booked immediately on eCareTherapy?
    `,
    a: `Yes, users have the option to filter therapists who are currently online and ready to be booked immediately on eCareTherapy.`,
  },
  {
    q: `What measures does eCareTherapy take to ensure the security of therapist-patient communications?
    `,
    a: `eCareTherapy provides secure and encrypted video, audio, or chat sessions to ensure the security of therapist-patient communications.
    `,
  },
  {
    q: `How does eCareTherapy support therapists in delivering exceptional care to their clients?

    `,
    a: `eCareTherapy supports therapists by providing a user-friendly platform, enabling them to manage their schedules and rates, and fostering a supportive environment for delivering exceptional care to their clients.

    `,
  },
  {
    q: `What are some of the ways in which eCareTherapy aims to break down barriers to mental health support?

    `,
    a: `eCareTherapy aims to break down barriers by offering a platform that emphasizes accessibility, choice, and quality care, and by providing a seamless and personalized experience for individuals seeking mental health support.

    `,
  },
  {
    q: `What role does the eCareTherapy platform play in empowering therapists?

    `,
    a: `The eCareTherapy platform empowers therapists by allowing them to set their own rates, manage their schedules, and connect with clients through secure video, audio, or chat sessions.

    `,
  },
  {
    q: `How does eCareTherapy LLC ensure that therapists can adjust their session rates as needed?

    `,
    a: `eCareTherapy LLC allows therapists to have the flexibility to establish their session rates, starting from a minimum amount, and to adjust them as needed based on their experience, expertise, and market demand.

    `,
  },
];
const QandA = () => {
  const { user } = useContext(AuthContext);
  const [opened_index, setOpenedIndex] = useState(null);

  useEffect(() => {
    trackScreenView("qa_screen", { screen_name: "Q&A", ...getUserTrackingParams(user) });
  }, []);

  const handleOnClick = (isFocused, i) => {
    if (isFocused) {
      setOpenedIndex(null);
      return;
    }
    setOpenedIndex(i);
  };
  return (
    <>
      <BannerSection banner={Banner} name={"Home"} title={"Q&A"} />
      <section className="py-5 termscontent">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              {questionAnswerArr.map((item, index) => {
                const isFocused = opened_index == index;
                return (
                  <React.Fragment key={index}>
                    <div
                      className="question_container"
                      onClick={() => {
                        handleOnClick(isFocused, index);
                      }}
                    >
                      <span>Q. {item.q.trim()}</span>{" "}
                      <span className="plus_minus">
                        {isFocused ? "-" : "+"}
                      </span>
                    </div>

                    {isFocused && (
                      <div className="question_container answer_container">
                        <span style={{ display: "inline" }}>
                          A. {item.a.trim()}{" "}
                        </span>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}

              <p style={{ fontSize: "1rem", marginTop: 50 }}>
                Feel free to ask for further clarification on any of these
                questions or for additional information!
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default QandA;
